import {ChangeDetectorRef, Component, Input, OnInit} from "@angular/core";
import {ApiService} from "~/app/core/api.service";
import {OfferService} from "~/app/core/offer-service/offer.service";
import {OfferInfo} from "~/app/core/model/offer-info";
import {momentNow, toDateStr} from "~/app/core/model/date-str";
import {OfferThumbnailInfo} from "~/app/core/model/offer-thumbnail-info";
import {OfferFilter} from "~/app/core/model/offer-filter";
import {HomeComponent} from "~/app/components/home/home.component";
import {CoreService} from "~/app/core/core.service";
import {AddressInfo} from "~/app/core/model/address-info";
import {LocationInfo} from "~/app/core/model/location-info";
import {ModalType} from "~/app/core/modal.service";
import {
  LocationServicesPopupComponent
} from "~/app/components/location-services-popup/location-services-popup.component";

@Component({
    selector: "offer-list-horizontal",
    templateUrl: "./offer-list-horizontal.component.html",
    styleUrls: ["./offer-list-horizontal.component.scss"]
})
export class OfferListHorizontalComponent implements OnInit {
  offerThumbnails: Map<number, OfferThumbnailInfo> = new Map<number, OfferThumbnailInfo>();

  // offers
  @Input() offers: Array<OfferInfo>;
  @Input() filter: OfferFilter;
  findingLocation: boolean = false;
  latitude: number = null;
  longitude: number = null;
  nearestAddress: AddressInfo = null;
  nearestAddressDistance: number = null;

  constructor(
    private readonly api: ApiService,
    private readonly cd: ChangeDetectorRef,
    private readonly offerService: OfferService,
    private homeComponent: HomeComponent,
    private readonly core: CoreService,
  ) {
  }

  ngOnInit(): void {
    // see OffersPage.ngOnInit
    this.updateOfferThumbnails();
    // TODO currently, we are getting the location for each row. This is causing many more geolocation requests than necessary. We should only do this once per search.
    // this.updateNearestLocations();
    this.homeComponent.locationInfo.subscribe((locationInfo) => {
      if (locationInfo != null) {
        this.longitude = locationInfo.longitude;
        this.latitude = locationInfo.latitude;
        for (let thumbnailInfo of this.offerThumbnails.values()) {
          if (thumbnailInfo.offer.addresses) {
            let nearestAddressDistance: number = null;
            let nearestAddress: AddressInfo = null;
            for (let address of thumbnailInfo.offer.addresses) {
              let calculatedDistance = this.calculateDistance(address);
              if (this.nearestAddressDistance == null || calculatedDistance < this.nearestAddressDistance) {
                nearestAddressDistance = calculatedDistance;
                nearestAddress = address;
              }
            }
            if (nearestAddress) {
              thumbnailInfo.location = nearestAddress.city + (nearestAddressDistance ? " " + nearestAddressDistance + "mi" : "");
            }
          }
        }
      }
    });

    // Init your component properties here.
    // this.activatedRoute.queryParamMap.subscribe((value: ParamMap) => {
    //   this.initOfferId = null;
    //   this.initAutoOpen = false;
    //   Log.debug(Log.Tag.OffersPage, "params: " + JSON.stringify(value));
    //   if (value.has("offerId")) {
    //     this.initOfferId = Number(value.get("offerId"));
    //     this.initTabId = this.freeOffers.length > 0 && this.freeOffers[0].id > 0 ? "free" : (this.couponOffers.length > 0 ? "discount" : null);
    //     this.initAutoOpen = true;
    //     if (value.has("autoOpen")) {
    //       this.initAutoOpen = value.get("autoOpen") === "true";
    //     }
    //     if (this.freeOffers.findIndex((offer) => this.initOfferId === offer.id) >= 0) {
    //       this.initTabId = "free";
    //     } else if (this.couponOffers.findIndex((offer) => this.initOfferId === offer.id) >= 0) {
    //       this.initTabId = "discount";
    //     }
    //   }
    // });
  }

  private getThumbnailInfo(offerInfo: OfferInfo) {
    this.updateOfferThumbnails();
    if (this.offerThumbnails.has(offerInfo.id))
      return this.offerThumbnails.get(offerInfo.id);
  }

  private updateThumbnailInfo(offerInfo: OfferInfo) {
    let offerThumbnailInfo = new OfferThumbnailInfo();
    offerThumbnailInfo.id = offerInfo.id;
    offerThumbnailInfo.company = offerInfo.companyName;
    offerThumbnailInfo.name = offerInfo.name;
    offerThumbnailInfo.image = offerInfo.imageUrl;
    offerThumbnailInfo.location = this.initLocation(offerInfo);
    offerThumbnailInfo.isFavorite = offerInfo.favorite;
    offerThumbnailInfo.isWebOffer = offerInfo.onlineOnly;
    offerThumbnailInfo.offer = offerInfo;
    return offerThumbnailInfo;
  }

  private initLocation(offerInfo: OfferInfo) {
    if (offerInfo.onlineOnly)
      return "Web Offer";
    else {
      // return first. This may change after we find the nearest location.
      for (let address of offerInfo.addresses) {
        return address.city;
      }
    }
  }

  private updateOfferThumbnails() {
    this.offers.forEach((offer) => {
        this.offerThumbnails.set(offer.id, this.updateThumbnailInfo(offer));
    });
  }

  public reloadOffers() {
    this.homeComponent.reloadOffers();
    this.updateOfferThumbnails();
  }

  public displayOffer(offerID: number) {
    this.homeComponent.displayOffer(offerID);
  }


  calculateDistance(address: AddressInfo): number {
    const distance = this.milesAwayPrecise(address);
    if (distance) {
      return distance > 1 ? Math.round(distance) : Math.round(distance * 10) / 10;
    }
    return null;
  }

  milesAwayPrecise(address: AddressInfo): number {
    if (this.hasMilesAway(address)) {
      const distance = LocationInfo.milesAway(
        { longitude: address.longitude, latitude: address.latitude },
        { longitude: this.longitude, latitude: this.latitude }
      );
      return distance;
    }
    return null;
  }

  hasMilesAway(address: AddressInfo): boolean {
    return !!address.latitude && !!address.longitude && !!this.longitude && !!this.latitude;
  }

  // update locationInfo
  // updateNearestLocations() {
  //   console.log("this.homeComponent.locationInfo: " + this.homeComponent.locationInfo);
  //   this.longitude = this.homeComponent.locationInfo.longitude;
  //   this.latitude = this.homeComponent.locationInfo.latitude;
  //   for (let thumbnailInfo of this.offerThumbnails.values()) {
  //     if (thumbnailInfo.offer.addresses) {
  //       let nearestAddressDistance: number = null;
  //       let nearestAddress: AddressInfo = null;
  //       for (let address of thumbnailInfo.offer.addresses) {
  //         let calculatedDistance = this.calculateDistance(address);
  //         if (this.nearestAddressDistance == null || calculatedDistance < this.nearestAddressDistance) {
  //           nearestAddressDistance = calculatedDistance;
  //           nearestAddress = address;
  //         }
  //       }
  //       if (nearestAddress) {
  //         thumbnailInfo.location = nearestAddress.city + (nearestAddressDistance ? " " + nearestAddressDistance + "mi" : "");
  //       }
  //     }
  //   }
    // this.findingLocation = true;
    // this.core.api.location_getLocationInfo().then(locationInfo => {
    //   this.longitude = locationInfo.longitude;
    //   this.latitude = locationInfo.latitude;
    //   for (let thumbnailInfo of this.offerThumbnails.values()) {
    //     if (thumbnailInfo.offer.addresses) {
    //       let nearestAddressDistance: number = null;
    //       let nearestAddress: AddressInfo = null;
    //       for (let address of thumbnailInfo.offer.addresses) {
    //         let calculatedDistance = this.calculateDistance(address);
    //         if (this.nearestAddressDistance == null || calculatedDistance < this.nearestAddressDistance) {
    //           nearestAddressDistance = calculatedDistance;
    //           nearestAddress = address;
    //         }
    //       }
    //       if (nearestAddress) {
    //         thumbnailInfo.location = nearestAddress.city +  (nearestAddressDistance ? " " + nearestAddressDistance + "mi" : "");
    //       }
    //     }
    //   }
    //   this.findingLocation = false;
    // }, (error) => {
    //   if (this.homeComponent.zip == null) {
    //     console.log("Error getting location");
    //     console.log(error);
    //   }
    //   this.findingLocation = false;
    // });
  // }

  // private loadOffers() {
  //   this.numFavorites = 0;
  //   this.freeOffers = this.getFreeOffers();
  //   this.featuredDiscountOffers = this.getDiscountOffers();
  //   this.flashOffers = this.getFlashOffers();
  //   this.myFavoriteOffers = this.getMyFavoriteOffers();
  //   this.myBouncebackOffers = this.getMyBouncebackOffers();
  //   this.mostPopularLocal = this.getMostPopularLocalOffers();
  //   this.recommendedOffers = this.getRecommendedOffers();
  //   this.newestOffers = this.getNewestOffers();
  //   this.numFavorites = this.featuredDiscountOffers.length;
  //   this.allOffers.forEach((o) => {
  //     if (o.addresses && o.addresses.length > 0 && !o.sample) this.mapOffers.push(o);
  //     // if (o.nextAvailableDate) this.notify.scheduleBouncebackNotification(o);
  //   });
  //   const numTotalOffers = this.api.offers_totalSearchOffers();
  //
  //   this.allowFiltering = this.settings.allowFiltering && this.settings.filteringMinOffers <= numTotalOffers;
  //
  //   if (this.settings.showShareCoupon && !this.isActiveSearch) {
  //     this.freeOffers.push({
  //       id: -1,
  //       free: false,
  //       bounceback: false,
  //       revealCost: 0,
  //       revealed: true,
  //       favoriteCost: 0,
  //       favorite: true,
  //       repeatUnlockCost: 0,
  //       repeatUnlocked: true,
  //       seenDate: toDateStr(momentNow().add(-1, "days")),
  //       sample: false,
  //       name: "Expecting more offers?",
  //       imageBannerText: "Don't worry, more offers are coming!",
  //       terms: "More and more offers will be coming to your area soon. Please help by SHARING the WhutsFree app with your friends!",
  //       expirationDate: toDateStr(momentNow().add(100, "days")),
  //       imageUrl: "images/redeemed_sunburst.png",
  //       companyId: -1,
  //       companyName: "WhutsFree",
  //       companyLogoUrl: "images/logo_transparent.png",
  //       companyWebUrl: "",
  //       reviewUrl: "",
  //       addresses: []
  //     });
  //   }
  //
  //   if (this.settings.showBusinessCoupon && !this.isActiveSearch) {
  //     this.freeOffers.push({
  //       id: -2,
  //       free: true,
  //       revealCost: 0,
  //       revealed: true,
  //       favoriteCost: 0,
  //       favorite: true,
  //       bounceback: false,
  //       repeatUnlockCost: 0,
  //       repeatUnlocked: true,
  //       seenDate: toDateStr(momentNow().add(-1, "days")),
  //       sample: false,
  //       name: "BUSINESS OWNERS",
  //       imageBannerText: "Want more customers? Start your FREE offer!",
  //       terms: "Contact us today to provide a free offer. It won't cost you anything and your customers will love you even more!",
  //       expirationDate: toDateStr(momentNow().add(100, "days")),
  //       imageUrl: "images/redeemed_sunburst.png",
  //       companyId: -1,
  //       companyName: "WhutsFree",
  //       companyLogoUrl: "images/logo_transparent.png",
  //       companyWebUrl: "",
  //       reviewUrl: "",
  //       addresses: []
  //     });
  //   }
  //
  //   if (this.isActiveSearch && this.freeOffers.length === 0) {
  //     this.freeOffers.push({
  //       id: -3,
  //       free: true,
  //       bounceback: false,
  //       revealCost: 0,
  //       revealed: true,
  //       favoriteCost: 0,
  //       favorite: true,
  //       repeatUnlockCost: 0,
  //       repeatUnlocked: true,
  //       seenDate: toDateStr(momentNow().add(-1, "days")),
  //       sample: false,
  //       name: "NO FREE MATCHES",
  //       imageBannerText: "We didn't find any FREE offers matching your search...",
  //       terms: "Your search didn't find any FREE offers. To reset your search, tap on the Reset Search button below.",
  //       expirationDate: toDateStr(momentNow().add(100, "days")),
  //       imageUrl: "images/search_not_found.png",
  //       companyId: -1,
  //       companyName: "WhutsFree",
  //       companyLogoUrl: "images/logo_transparent.png",
  //       companyWebUrl: "",
  //       reviewUrl: "",
  //       addresses: []
  //     });
  //   }
  //
  //   if (this.couponOffers.length === 0) {
  //     this.couponOffers.push({
  //       id: -4,
  //       free: false,
  //       bounceback: true,
  //       revealCost: 0,
  //       revealed: true,
  //       favoriteCost: 0,
  //       favorite: true,
  //       repeatUnlockCost: 0,
  //       repeatUnlocked: true,
  //       seenDate: toDateStr(momentNow().add(-1, "days")),
  //       sample: false,
  //       name: "NO FAVORITES YET",
  //       imageBannerText: "Start adding favorites",
  //       terms: "Visit the Discover tab to browse the available offers. You can 'Favorite' unlocked offers using the 'Heart' button. Return to the 'My Favorites' tab to see your favorite offers.",
  //       expirationDate: toDateStr(momentNow().add(100, "days")),
  //       imageUrl: "images/search_not_found.png",
  //       companyId: -1,
  //       companyName: "WhutsFree",
  //       companyLogoUrl: "images/logo_transparent.png",
  //       companyWebUrl: "",
  //       reviewUrl: "",
  //       addresses: []
  //     });
  //   } else if (this.isActiveSearch && this.couponOffers.length === 0) {
  //     this.couponOffers.push({
  //       id: -3,
  //       free: false,
  //       bounceback: true,
  //       revealCost: 0,
  //       revealed: true,
  //       favoriteCost: 0,
  //       favorite: true,
  //       repeatUnlockCost: 0,
  //       repeatUnlocked: true,
  //       seenDate: toDateStr(momentNow().add(-1, "days")),
  //       sample: false,
  //       name: "NO COUPON MATCHES",
  //       imageBannerText: "We didn't find any coupons matching your search...",
  //       terms: "Your search didn't find any discount coupons. To clear your search text, tap on Reset Search below.",
  //       expirationDate: toDateStr(momentNow().add(100, "days")),
  //       imageUrl: "images/search_not_found.png",
  //       companyId: -1,
  //       companyName: "WhutsFree",
  //       companyLogoUrl: "images/logo_transparent.png",
  //       companyWebUrl: "",
  //       reviewUrl: "",
  //       addresses: []
  //     });
  //   }
  // }
  //
  // getOffers(): { company: String, name: String, image: String }[] {
  //   // let offerTmp = {
  //   //   company: 'Some store',
  //   //   name: 'FREE something',
  //   //   image: '*insert Image*'
  //   // };
  //   // let offers = [offerTmp, offerTmp, offerTmp];
  //   let offers = [];
  //   // See SearchingPage.performGPSSearch
  //   // ideally, the search would happen on app startup, or whenever it's necessary to query the back-end, and we would
  //   // just filter the results that are stored locally. But baby steps while we figure this stuff out...
  //   this.offerService.performSearch().then((result) => {
  //     for (let offerInfo of result) {
  //       offers.push({company: offerInfo.companyName, name: offerInfo.name, image: offerInfo.imageUrl});
  //     }
  //   });
  //   return offers;
  // }
}
